// src/components/ClientSelector.js
import React, { useState } from 'react';
import { useClient } from '../contexts/ClientContext';
import './ClientSelector.css';

const ClientSelector = () => {
  const { clienteAtual, loading, error, setCliente, clearCliente } = useClient();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [inputCodigo, setInputCodigo] = useState('');
  const [localError, setLocalError] = useState('');

  const handleOpenDialog = () => {
    setInputCodigo('');
    setLocalError('');
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setInputCodigo('');
    setLocalError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

        if (!inputCodigo.trim()) {
      setLocalError('Digite o código do cliente');
      return;
    }

    const codigo = inputCodigo.padStart(5, '0'); // garante 5 dígitos com zeros à esquerda
    
    const sucesso = await setCliente(codigo.trim());
    
    if (sucesso) {
      handleCloseDialog();
    } else {
      setLocalError(error || 'Erro ao buscar cliente');
    }
  };

  const handleClear = () => {
    if (window.confirm('Deseja remover o cliente da sessão?')) {
      clearCliente();
    }
  };

  const truncateNome = (nome) => {
    if (!nome) return '';
    if (nome.length <= 20) return nome;
    return nome.substring(0, 17) + '...';
  };

  return (
    <>
      <div className="client-selector">
        {clienteAtual.codCliente ? (
          <div className="client-info">
            <span className="client-label">Cliente:</span>
            <span className="client-codigo">{clienteAtual.codCliente}</span>
            <span className="client-nome">- {truncateNome(clienteAtual.nomeCliente)}</span>
            <button className="btn-alterar" onClick={handleOpenDialog}>
              [ALTERAR]
            </button>
            <button className="btn-limpar" onClick={handleClear} title="Remover cliente da sessão">
              ✕
            </button>
          </div>
        ) : (
          <button className="btn-selecionar-cliente" onClick={handleOpenDialog}>
            + Selecionar Cliente
          </button>
        )}
      </div>

      {dialogOpen && (
        <div className="dialog-overlay" onClick={handleCloseDialog}>
          <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
            <div className="dialog-header">
              <h3>Selecionar Cliente</h3>
              <button className="btn-fechar-dialog" onClick={handleCloseDialog}>
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} className="dialog-form">
              <div className="form-group">
                <label htmlFor="codigo-cliente">Código do Cliente (5 dígitos):</label>
                <input
                    type="text"
                    id="codigo-cliente"
                    value={inputCodigo}
                    onChange={(e) => {
                      const valor = e.target.value.replace(/\D/g, '').slice(0, 5);
                      setInputCodigo(valor);
                      setLocalError('');
                    }}
                    onBlur={() => {
                      // ao sair do campo, mostra a máscara completa 00000
                      setInputCodigo((v) => v.padStart(5, '0'));
                    }}
                    onFocus={() => {
                      // ao focar, remove zeros à esquerda para facilitar a digitação
                      setInputCodigo((v) => v.replace(/^0+/, ''));
                    }}
                    placeholder="00000"
                    maxLength={5}
                    disabled={loading}
                    autoFocus
                    inputMode="numeric"
                  />
              </div>

              {localError && (
                <div className="error-message-dialog">
                  {localError}
                </div>
              )}

              <div className="dialog-actions">
                <button
                  type="button"
                  className="btn-cancelar"
                  onClick={handleCloseDialog}
                  disabled={loading}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn-confirmar"
                  disabled={loading || !inputCodigo.trim()}
                >
                  {loading ? 'Carregando...' : 'Confirmar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default ClientSelector;